






import { Component, Vue } from 'vue-property-decorator';
import PageApiAgent from '../../services/page-api-agent';
import CardMenu from '../../components/CardMenu.vue';
import { CardMenuItem } from '../../interfaces/card-menu.interface';
import TranslationApiAgent from '../../services/translation-api-agent';

// @ts-ignore
@Component({
	components: {
		'card-menu': CardMenu
	}
})
export default class AdminPages extends Vue {

	private pages: CardMenuItem[] = [];
  constructor(private pageApiAgent = PageApiAgent, private translationsApiAgent = TranslationApiAgent) {
    super();
  }

  mounted() {
      this.pageApiAgent.getFullList().then(result => {
				result.forEach(page => {
					this.pages.push({
						route: '/admin/pages/' + page.id,
						title: page.title
					});
				});
				this.pages.push({
					route: '/admin/pages/new',
					title: this.translationsApiAgent.get('admin::pages::new')
				});
			});
  }
}

